import React from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation"
// import Swiper core and required modules
import SwiperCore, { Navigation } from 'swiper';
import HomeSingleProject from '../../../../components/HomeSingleProject/HomeSingleProject';
SwiperCore.use([Navigation]);

const Projects = () => {
   return (
      <>
         <section className="tp-project-area white-bg position-relative">
            <div className="tp-project-shape"></div>
            <div className="tp-project-wrapper grey-bg pt-120 wow fadeInUp" data-wow-delay=".2s">
               <div className="section-title-wrapper text-center mb-55 grey-bg">
                  <h5 className="tp-section-subtitle common-yellow-shape section__sm__title mb-20">Quelques projets terminés</h5>
                  <h2 className="tp-section-title mb-20">Chaque projet est différent <br />Chaque client est unique</h2>
               </div>
               <div className="tp-project-active swiper-container">
                  <Swiper
                     spaceBetween={30}
                     slidesPerView={1}
                     className='swiper-wrapper'
                     autoplay={{ delay: 6000 }}
                     breakpoints={{
                        550: {
                           slidesPerView: 2,
                        },
                        768: {
                           slidesPerView: 2,
                        },
                        1200: {
                           slidesPerView: 3,
                        },
                        1400: {
                           slidesPerView: 3,
                        },
                        1600: {
                           slidesPerView: 4,
                        },
                     }}
                     // onSlideChange={() => console.log('slide change')}
                     // onSwiper={(swiper) => console.log(swiper)}
                  >

                     <SwiperSlide>
                        <HomeSingleProject project_img_num="1" title="Nettoyage de salle de bain" />
                     </SwiperSlide>

                     <SwiperSlide>
                        <HomeSingleProject project_img_num="2" title="Nettoyage de la cuisine" />
                     </SwiperSlide>

                     <SwiperSlide>
                        <HomeSingleProject project_img_num="3" title="Nettoyage des chambres" />
                     </SwiperSlide>

                     <SwiperSlide>
                        <HomeSingleProject project_img_num="4" title="Nettoyage de bureaux" />
                     </SwiperSlide> 
                     <SwiperSlide>
                        <HomeSingleProject project_img_num="3" title="Nettoyage des chambres" />
                     </SwiperSlide>

                  </Swiper>

               </div>
            </div>
         </section>
      </>
   );
};

export default Projects;